import {type LngLat, MapMarker} from '@yandex-delivery/blocks'
import React from 'react'

import * as classes from './Waypoint.classes'

type Props = {
  coords: LngLat
}

const Waypoint: React.FC<Props> = props => {
  return (
    <MapMarker coordinates={props.coords}>
      <div className={classes.root} />
    </MapMarker>
  )
}

export {Waypoint}
